import { LayoutComponent } from "../components";
import { connect } from "react-redux";
import { GetDataLayoutLayoutAction, SetDataLayoutLayoutAction,GetDataNotificationAction , UpdateDataNotificationAction, LogOut} from "../actions";

const mapStateToProps = state => {
    return {
        ...state,
        DataLayout: state.allLayoutReducers.layoutALLReducer.layoutReducer.DataLayout,
        DataNoti: state.allLayoutReducers.layoutALLReducer.NotiReducer.DataNoti,
        isLogout: state.allLayoutReducers.layoutALLReducer.LogoutReducer.isLogout
    };
};

const mapDispatchToProps = dispatch => {
    return {
        GetDataLayout: () => {
            dispatch(GetDataLayoutLayoutAction());
        },
        SetDataLayout: (DataLayout) => {
            dispatch(SetDataLayoutLayoutAction(DataLayout));
        },
        GetDataNoti: (DataNoti) => {
            dispatch(GetDataNotificationAction(DataNoti));
        },
        LogOut: () => {
            dispatch(LogOut());
        },
        UpdateDataNotification: () =>{
            dispatch(UpdateDataNotificationAction());
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(LayoutComponent);